import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Redirect, withRouter } from 'react-router-dom'
import moment from 'moment'
import TimePicker from 'react-times'
import 'react-times/css/material/default.css'
import RoleControlled from '../_common/RoleControlled'
import { savePush } from '../../actions'
import Loader from '../_common/Loader'
import MaterialDatePicker from '../_common/MaterialDatePicker'
// import DateTimePicker from '../_common/DateTimePicker'

class AddPush extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      recipient_category: 'all',
      recipient_id: '',
      title: '',
      content: '',
      image: '',
      image_url: '',
      image_error: '',
      youtube_url: '',
      hp_url: '',
      send: '2',
      timer_date: '',
      timer_time: ''
    }
  }

  componentDidMount () {
    if (this.props.match.params.category) {
      const { category, id } = this.props.match.params
      let recipient_category
      switch (category) {
        case 'owner':
          recipient_category = '0'
          break
        case 'property':
          recipient_category = '1'
          break
        case 'resident':
          recipient_category = '2'
          break
        default:
          break
      }
      this.setState({
        recipient_category,
        recipient_id: id
      })
    }
  }

  _handleContentChange (key, e) {
    this.setState({ [key]: e.target.value })
  }

  _handleDateChange = (timer_date) => {
    this.setState({ timer_date })
  }
  _handleTimeChange = (time) => {
    const timer_time = `${time.hour}:${time.minute}`
    this.setState({ timer_time })
  }

  _handleRecipientChange (e) {
    const recipient_category = e.target.value
    if (recipient_category === 'all') {
      this.setState({ recipient_id: '' })
    }
    this.setState({ recipient_category })
  }

  _handlePushChange (e) {
    //  0 ("now") || 1("timer)|| 2("do_nothing")
    const send = e.target.value
    if (send === '0' || send === '2') {
      this.setState({
        timer_date: '',
        timer_time: ''
      })
    }
    if (send === '1') {
      const timer_date = moment().format('YYYY-MM-DD')
      const timer_time = moment().format('HH:mm')
      this.setState({
        timer_date,
        timer_time
      })
    }
    this.setState({ send })
  }

  async _handleImageChange (e) {
    const image = e.target.files[0]
    if (image) {
      if (
        (image.type === 'image/png' || image.type === 'image/jpeg' || image.type === 'image/jpeg') &&
        (image.name.indexOf('png') > 0 || image.name.indexOf('jpeg') > 0 || image.name.indexOf('jpg') > 0)
      ) {
        let reader = new FileReader()
        reader.onload = (e) => {
          this.setState({image_url: e.target.result})
        }
        reader.readAsDataURL(e.target.files[0])
        this.setState({ image })
      } else {
        this.setState({ image_error: '画像ファイル外を選択しました。\n確認の上でもう一度画像ファイルを選択してください。' })
      }
    }
  }

  _handleFormSubmit (e) {
    e.preventDefault()
    if (this.props.push.postSuccess === null) {
      const {
        recipient_category,
        recipient_id,
        title,
        content,
        youtube_url,
        hp_url,
        send,
        timer_date,
        timer_time
      } = this.state

      let timer = null
      if (timer_date && timer_time) {
        timer = `${moment(timer_date).format('YYYY/MM/DD')} ${timer_time}`
      }

      const data = {
        title,
        content,
        youtube_url,
        hp_url,
        send: Number(send),
        timer
      }
      if (recipient_category !== 'all') {
        data.recipient = {
          type: Number(recipient_category),
          id: recipient_id
        }
      } else {
        console.log('no recipient')
        data.recipient = null
      }
      console.log('data: ', data)
      this.props.savePush(data, this.state.image)
    }
  }

  _resetImage () {
    this.setState({ image: '', image_url: '' })
    document.getElementById('image').value = ''
  }

  _renderImageLabel () {
    if (this.state.image_url) {
      return (
        <div className="label_container">
          <label className="image_input_label image_selected" htmlFor="image">
            <img className="img-responsive" src={this.state.image_url} alt=""/>
          </label>
          <div className="delete_container" onClick={this._resetImage.bind(this)}>
            <span></span>
            <span></span>
          </div>
        </div>
      )
    }
    return (
      <div className="label_container">
        <label className="image_input_label image_blank" htmlFor="image">
          <svg className="add" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="16"></line>
            <line x1="8" y1="12" x2="16" y2="12"></line>
          </svg>
        </label>
      </div>
    )
  }

  _renderPickers () {
    if (this.state.send === '1') {
      return (
        <div className="pickers">
          <MaterialDatePicker
            selectedDate={ this.state.timer_date }
            updateDate={this._handleDateChange}
          />
          <TimePicker
            time={this.state.timer_time}
            onTimeChange={this._handleTimeChange.bind(this)}
            theme="material"
          />
        </div>
      )
    }
    return null
  }

  _renderRecipientInput () {
    if (this.state.recipient_category && this.state.recipient_category !== 'all') {
      return (
        <div className="inline-input-group recipient_id_container">
          <label className="label" htmlFor="recipient_id">ID</label>
          <input
            type="text"
            id="recipient_id"
            placeholder="IDを入力して下さい。"
            value={this.state.recipient_id}
            onChange={this._handleContentChange.bind(this, 'recipient_id')}
          />
        </div>
      )
    }
    return null
  }

  _renderForm () {
    if (!this.props.push.loading) {
      return (
        <form onSubmit={ this._handleFormSubmit.bind(this) }>
          <div className="input-group flex">
            <label className="label required">送り先</label>
            <div className="input_container flex">
              <div className="radio-group radio-group-inline">
                <input
                  type="radio"
                  name="recipient"
                  id="all"
                  value="all"
                  required
                  checked={ !this.state.recipient_category || this.state.recipient_category === 'all' }
                  onChange={this._handleRecipientChange.bind(this)}
                />
                <label htmlFor="all">すべてのユーザー</label>
              </div>
              <RoleControlled role={this.props.user.user_role} acceptedRoles={[0]}>
                <div className="radio-group radio-group-inline">
                  <input
                    type="radio"
                    name="recipient"
                    id="owner"
                    value="0"
                    checked={ this.state.recipient_category === '0' }
                    onChange={this._handleRecipientChange.bind(this)}
                  />
                  <label htmlFor="owner">管理会社・オーナーで絞り込み</label>
                </div>
              </RoleControlled>
              <div className="radio-group radio-group-inline">
                <input
                  type="radio"
                  name="recipient"
                  id="property"
                  value="1"
                  checked={ this.state.recipient_category === '1' }
                  onChange={this._handleRecipientChange.bind(this)}
                />
                <label htmlFor="property">物件で絞り込み</label>
              </div>
              <div className="radio-group radio-group-inline">
                <input
                  type="radio"
                  name="recipient"
                  id="resident"
                  value="2"
                  checked={ this.state.recipient_category === '2' }
                  onChange={this._handleRecipientChange.bind(this)}
                />
                <label htmlFor="resident">入居者で絞り込み</label>
              </div>
              { this._renderRecipientInput() }
            </div>
          </div>
          <div className="input-group flex">
            <label className="label required" htmlFor="title">タイトル</label>
            <input
              type="text"
              id="title"
              placeholder="タイトル"
              value={this.state.title}
              onChange={this._handleContentChange.bind(this, 'title')}
              required
            />
          </div>
          <div className="input-group flex">
            <label className="label required" htmlFor="content">本文</label>
            <textarea
              id="content"
              rows="10"
              placeholder="本文"
              onChange={this._handleContentChange.bind(this, 'content')}
              value={this.state.content}
              required
            ></textarea>
          </div>
          <div className="input-group flex">
            <label className="label" htmlFor="image">
                画像
              <div className="smallest">JPEG・PNGファイルのみ</div>
            </label>
            <div className="image_input_container flex">
              { this._renderImageLabel() }
              <div>
                <div className="image_error small">{ this.state.image_error }</div>
                <input
                  type="file"
                  id="image"
                  onChange={this._handleImageChange.bind(this)}
                />
              </div>
            </div>
          </div>
          <div className="input-group flex">
            <label className="label" htmlFor="youtube">動画リンク</label>
            <input
              type="url"
              id="youtube"
              placeholder="動画URLを入力して下さい。"
              value={this.state.youtube_url}
              onChange={this._handleContentChange.bind(this, 'youtube_url')}
            />
          </div>
          <div className="input-group flex">
            <label className="label" htmlFor="website_url">WebサイトURL</label>
            <input
              type="url"
              id="website_url"
              placeholder="WebサイトURLを入力して下さい。"
              value={this.state.hp_url}
              onChange={this._handleContentChange.bind(this, 'hp_url')}
            />
          </div>
          <div className="input-group flex">
            <label className="label">配信</label>
            <div className="input_container flex">
              <div className="radio-group radio-group-inline">
                <input
                  type="radio"
                  name="push"
                  id="push_now"
                  value="0"
                  checked={ this.state.send === '0'}
                  required
                  onChange={this._handlePushChange.bind(this)}
                />
                <label htmlFor="push_now">すぐに配信する</label>
              </div>
              <div className="radio-group radio-group-inline">
                <input
                  type="radio"
                  name="push"
                  id="set_timer"
                  value="1"
                  checked={ this.state.send === '1'}
                  onChange={this._handlePushChange.bind(this)}
                />
                <label htmlFor="set_timer">配信を予約する</label>
              </div>
              <div className="radio-group radio-group-inline">
                <input
                  type="radio"
                  name="push"
                  id="do_nothing"
                  value="2"
                  checked={ this.state.send === '2'}
                  onChange={this._handlePushChange.bind(this)}
                />
                <label htmlFor="do_nothing">このまま保存</label>
              </div>
              { this._renderPickers() }
            </div>
          </div>

          <div className="button_container flex justify-center">
            <button type="button" className="btn cancel_btn" onClick={() => { this.props.history.replace('/push') }}>キャンセル</button>
            <button className="btn submit_btn" type="submit">保存</button>
          </div>
        </form>
      )
    }
    return <Loader classname="loader_dot_circle"/>
  }

  render () {
    if (this.props.push && this.props.push.postSuccess) {
      return <Redirect to='/push' />
    }
    return (
      <section className="push_form">
        <h4 className="page_title bold">Push通知</h4>
        { this._renderForm() }
      </section>
    )
  }
}

function mapStateToProps ({ user, push }) {
  return { user, push }
}

export default withRouter(connect(mapStateToProps, { savePush })(AddPush))



// WEBPACK FOOTER //
// ./src/components/PushNotifications/AddPush.js